import { gql } from '@apollo/client';

export const GET_USERNAME = gql`
  query GetCustomerQuery {
    profile {
      id
      username
    }
  }
`;
